import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link, useSearch } from '@tanstack/react-router';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { authApi } from '@watchparty/shared';
export function VerifyEmailPage() {
    const { token, email } = useSearch({ from: '/verify-email' });
    const [state, setState] = useState('loading');
    const [errorMessage, setErrorMessage] = useState('');
    useEffect(() => {
        if (!token || !email) {
            setErrorMessage('Invalid verification link.');
            setState('error');
            return;
        }
        authApi.verifyEmail(token, email)
            .then(() => setState('success'))
            .catch((err) => {
            setErrorMessage(err instanceof Error ? err.message : 'This link is invalid or has expired.');
            setState('error');
        });
    }, [token, email]);
    return (_jsx("div", { style: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--color-bg)',
            padding: '24px',
        }, children: _jsxs("div", { style: {
                width: '100%',
                maxWidth: '420px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
            }, children: [state === 'loading' && (_jsxs(_Fragment, { children: [_jsx(Loader2, { size: 40, style: { color: 'var(--color-accent)', animation: 'spin 1s linear infinite' } }), _jsx("p", { style: { fontFamily: 'var(--font-family-body)', fontSize: '1rem', color: 'var(--color-text-muted)' }, children: "Verifying your email..." }), _jsx("style", { children: `@keyframes spin { to { transform: rotate(360deg); } }` })] })), state === 'success' && (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                                width: '56px', height: '56px', borderRadius: 'var(--radius-full)',
                                background: 'var(--color-surface-raised)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }, children: _jsx(CheckCircle, { size: 28, style: { color: 'var(--color-success, #4caf50)' } }) }), _jsx("h1", { style: { fontFamily: 'var(--font-family-heading)', fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-text)' }, children: "Email verified!" }), _jsx("p", { style: { fontFamily: 'var(--font-family-body)', fontSize: '0.9375rem', color: 'var(--color-text-muted)', lineHeight: 1.6 }, children: "Your email has been verified. You can now sign in to your account." }), _jsx(Link, { to: "/", style: {
                                display: 'inline-block',
                                marginTop: '8px',
                                padding: '10px 24px',
                                background: 'var(--color-accent)',
                                color: 'var(--color-text-inverse)',
                                textDecoration: 'none',
                                borderRadius: 'var(--radius-md)',
                                fontFamily: 'var(--font-family-body)',
                                fontSize: '0.9375rem',
                                fontWeight: 600,
                            }, children: "Sign In" })] })), state === 'error' && (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                                width: '56px', height: '56px', borderRadius: 'var(--radius-full)',
                                background: 'var(--color-surface-raised)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }, children: _jsx(XCircle, { size: 28, style: { color: 'var(--color-danger)' } }) }), _jsx("h1", { style: { fontFamily: 'var(--font-family-heading)', fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-text)' }, children: "Verification failed" }), _jsx("p", { style: { fontFamily: 'var(--font-family-body)', fontSize: '0.9375rem', color: 'var(--color-text-muted)', lineHeight: 1.6 }, children: errorMessage }), _jsx(Link, { to: "/", style: {
                                display: 'inline-block',
                                marginTop: '8px',
                                fontFamily: 'var(--font-family-body)',
                                fontSize: '0.9375rem',
                                color: 'var(--color-accent)',
                                textDecoration: 'underline',
                            }, children: "Back to sign in" })] }))] }) }));
}
